import React, { memo } from "react";
import { Grid, Container, Button } from "@mui/material";
import { DetailsMain, ButtonMain } from "./styles/DetailsHeaderStyle";

const DetailsHeader = ({ handleButtonClick, showOnMobile }) => {
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <Container maxWidth="lg">
        <DetailsMain>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <ButtonMain>
                <Button
                  disableRipple
                  onClick={
                    isMobile ? (e) => handleButtonClick("OrderDetails") : null
                  }
                  className={
                    isMobile && showOnMobile === "OrderDetails"
                      ? "activebtn"
                      : "nonactivebtn"
                  }
                >
                  Order Details
                </Button>
              </ButtonMain>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <ButtonMain>
                <Button
                  disableRipple
                  onClick={
                    isMobile ? (e) => handleButtonClick("BookingStatus") : null
                  }
                  className={
                    isMobile && showOnMobile === "BookingStatus"
                      ? "activebtn"
                      : "nonactivebtn"
                  }
                >
                  Booking Status
                </Button>
              </ButtonMain>
            </Grid>
          </Grid>
        </DetailsMain>
      </Container>
    </>
  );
};

export default memo(DetailsHeader);
